import React, { useState } from 'react';
import { Navigate, useParams } from 'react-router';

import { faFileCheck } from '@fortawesome/pro-regular-svg-icons/faFileCheck';

import { StartPiaDrawer } from '../../../detail/drawer/pia/StartPiaDrawer';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

export const InitiatePia = ({ policy }: { policy: string }) => {
  const copy = 'Initiate Post Issue Audit';
  const iconContainerClasses = `${styles.IconLinkContainer} ${styles.RightNavIconLinkContainer} ${styles.RightSidebar}`;

  // For controlling the EvidenceDrawer component
  const [isOpen, setIsOpen] = useState(false);
  const openDrawer = () => {
    setIsOpen(true);
  };

  const { id } = useParams<{ id: string }>();
  if (id === undefined) {
    return <Navigate to={{ pathname: '/' }} />;
  }

  return (
    <>
      <StartPiaDrawer
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        applicationId={+id}
        policy={policy}
      />
      <NavLink
        icon={faFileCheck}
        iconClassName={styles.Icon}
        iconContainerClassName={iconContainerClasses}
        textClassName={styles.LinkRight}
        copy={copy}
        onClick={openDrawer}
      />
    </>
  );
};
